'use client'
import ComponentTransition from "./../../../common/component/element/ComponentTransition";
import { motion } from "framer-motion";
import React from "react";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; 

export default function OurValues() {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleNavigate = () => {
    navigate("/vision#OutlineCards"); // Navigate to the Vision page with an anchor to OutlineCards
  };

  return (
    <motion.section 
      initial={{ x: "-100%" , borderRadius: '300px'}}
      whileInView={{ x: "0%", borderRadius: '0px' }}
      transition={{
        type: "tween",
        ease: [0.8, 0.2, 0, 1],
        duration: 1,
      }}
      viewport={{once: true}}
      className="w-full flex justify-center items-center py-12 md:py-24 lg:py-32 bg-black lg:px-10 px-5"
    >
      <ComponentTransition delay={0.7} className="container px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <div className="space-y-2">
            <div className="inline-block rounded-lg bg-black px-3 py-1 text-sm ">
              Core Values
            </div>
            <h2 className="text-3xl text-white font-bold tracking-tighter sm:text-5xl">
              What We Stand For
            </h2>
            <p className="max-w-[900px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
              Our values guide our decisions and actions. They are the
              foundation of our company culture.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
          {/* Value Cards */}
          <div className="flex border-[1px] relative group z-[9] hover:border-black border-white overflow-hidden rounded-3xl flex-col items-center text-center p-6">
            <div className="absolute w-[100px] h-[100px] z-[-9] group-hover:lg:w-[100%] group-hover:lg:h-[100%] inset-0 rounded-full group-hover:lg:rounded-none translate-y-[170%] transition-all duration-500 bg-[#BDFF1C] group-hover:lg:translate-y-[0%]"></div>
            <FaCheck className="h-6 w-6 text-blue-500" />
            <h1 className="text-2xl group-hover:lg:text-black transition-all duration-300 text-white font-semibold">
              Empathy
            </h1>
            <p className="mt-2 group-hover:lg:text-black transition-all duration-300 text-white">
              We understand the challenges small businesses face because we’ve been there.
            </p>
          </div>
          <div className="flex border-[1px] relative group z-[9] hover:border-black border-white overflow-hidden rounded-3xl flex-col items-center text-center p-6">
            <div className="absolute w-[100px] h-[100px] z-[-9] group-hover:lg:w-[100%] group-hover:lg:h-[100%] inset-0 rounded-full group-hover:lg:rounded-none translate-y-[170%] transition-all duration-500 bg-[#BDFF1C] group-hover:lg:translate-y-[0%]"></div>
            <FaCheck className="h-6 w-6 text-blue-500" />
            <h1 className="text-2xl group-hover:lg:text-black transition-all duration-300 text-white font-semibold">
              Innovation
            </h1>
            <p className="mt-2 group-hover:lg:text-black transition-all duration-300 text-white">
              Constantly reimagining what’s possible with technology.
            </p>
          </div>
          <div className="flex border-[1px] relative group z-[9] hover:border-black border-white overflow-hidden rounded-3xl flex-col items-center text-center p-6">
            <div className="absolute w-[100px] h-[100px] z-[-9] group-hover:lg:w-[100%] group-hover:lg:h-[100%] inset-0 rounded-full group-hover:lg:rounded-none translate-y-[170%] transition-all duration-500 bg-[#BDFF1C] group-hover:lg:translate-y-[0%]"></div>
            <FaCheck className="h-6 w-6 text-blue-500" />
            <h1 className="text-2xl group-hover:lg:text-black transition-all duration-300 text-white font-semibold">
              Inclusivity
            </h1>
            <p className="mt-2 group-hover:lg:text-black transition-all duration-300 text-white">
              Dedicated to helping minority- and women-owned businesses succeed.
            </p>
          </div>
        </div>

  {/* Orange Button */}
  <div className="flex justify-center mt-12">
  <button
    onClick={handleNavigate}
    className="px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-all duration-300"
  >
    Learn More
  </button>
</div>
</ComponentTransition>
</motion.section>
);
}

